module.exports = __webpack_public_path__ + "static/media/Mankey_gaussian2.b21ba22d.png";